module.exports = __webpack_public_path__ + "static/media/obs.c897582e.JPG";